import Vue from 'vue';

const mixinGetters = () => {
    return {
        getResponse(state) {
            return state['response'];
        },
        getList(state) {
            let list = state[state.repositoryName];

            let extraFeeds = state.extraFeeds;

            if (extraFeeds && extraFeeds.length) {
                // if (state[state.repositoryName].gamesIdx) {
                list = [...list];
                let gamesIdx = state.gamesIdx[state.repositoryName];

                let position = gamesIdx[state.filters.customEventId] + 5;

                extraFeeds.forEach((feed) => {
                    list.splice(position, 0, feed);
                    position++;
                });
                // }
            }

            return list;
        },
        getStats(state) {
            return state.stats;
        },
        getFilters(state) {
            return state.filters;
        },
        getOptions(state) {
            return state.options;
        },
        getRepositoryName(state) {
            return state.repositoryName;
        },
        getIsShowExtraFilters(state) {
            return state.isShowExtraFilters;
        },
    };
};

export default mixinGetters;
